import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sales-agent-info',
  templateUrl: './sales-agent-info.component.html',
  styleUrl: './sales-agent-info.component.css'
})
export class SalesAgentInfoComponent {

  @Input() awaitingEscalation: any;
  @Input() customerDetailCheck: any;
  @Input() kycComponentModeEnum: any;

  @Output() validSalesReplacement = new EventEmitter<any>()


  validateSales(check) {
    this.validSalesReplacement.emit(check);
  }
}
